function isAnimationControls(v) {
    return (v !== null &&
        typeof v === "object" &&
        typeof v.start === "function");
}

export { isAnimationControls };
//# sourceMappingURL=is-animation-controls.mjs.map
